<template>
  <div class="centered-container">

    <md-content class="md-class">
      <div class="title">
        <img
          src="/static/logo_azul.png"
          style="height: 40px">
      </div>
      <div class="message">
        <p>
          Verifique a data do suporte referente ao seu serial o mesmo está com
          data de suporte expirada. Entre em contato pelo telefone 0800 707 0122.
        </p>
      </div>
      <div class="div-buttom-back">
        <md-button
          class="md-icon-back"
          @click="backLogin()">
          <md-icon>keyboard_backspace
          </md-icon>
          <md-tooltip md-direction="bottom">Voltar para o login</md-tooltip>
        </md-button>
      </div>
    </md-content>

    <div class="app-footer wrapper-sm">
      <div class="row pos-rlt text-center">
        <img
          alt="Compufour"
          src="/static/logo-compufour.png"
          class="pull-left pos-abt footer-logo-c4">
        <div class="col-md-12">
          <nav class="link-list list-inline-ui m-b-none pull-left w-full"/>
          <small class="app-footer-copy m-t-xs pull-left w-full">
            Copyright © {{ dateAtual }} Zucchetti. Todos os direitos reservados
          </small>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SupportLimitDate',
  data() {
    return {
      dateAtual: moment().format('YYYY'),
    };
  },
  methods: {

    backLogin() {
      this.$router.push({ name: 'Login' })
    }
  }
};
</script>

<style type="text/css">
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
}
.title {
  text-align: center;
  margin-bottom: 30px;
  color: #1b8af1;
  font-size: 34px;
  font-weight: 300;
}
.md-class{
  z-index: 1;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
  background-color: #ededed!important;
}
.message{
  text-align: center;
  margin-bottom: 30px;
  color: #7e7e7e;
  font-size: 20px;
  font-weight: 300;
}
.md-icon-back {
    width: 30px;
    min-width: 40px;
    height: 40px;
    margin: 0 6px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/public/customException/SupportLimitDate.vue